export default "__VITE_ASSET__a73ea132__"